import React from "react";

/* BPM logo — matches the hero atomic mark */
export const Logo = ({ size = 38 }) => {
  return (
    <div className="flex items-center gap-3" data-testid="bpm-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden>
        <ellipse cx="20" cy="20" rx="17" ry="6" fill="none" stroke="var(--bpm-cream)" strokeWidth="1" opacity="0.5" transform="rotate(0 20 20)" />
        <ellipse cx="20" cy="20" rx="17" ry="6" fill="none" stroke="var(--bpm-teal)" strokeWidth="1" opacity="0.9" transform="rotate(60 20 20)" />
        <ellipse cx="20" cy="20" rx="17" ry="6" fill="none" stroke="var(--bpm-coral)" strokeWidth="1" opacity="0.9" transform="rotate(-60 20 20)" />
        <circle cx="20" cy="20" r="5" fill="var(--bpm-orange)" />
        <circle cx="20" cy="20" r="5" fill="none" stroke="var(--bpm-cream)" strokeWidth="0.75" />
      </svg>
      <div className="leading-none">
        <div className="font-display text-[17px]" style={{ letterSpacing: "-0.02em", color: "var(--bpm-cream)" }}>
          BPM: Boston Pro Marketing
        </div>
        <div
          className="mt-1.5"
          style={{
            color: "var(--bpm-muted)",
            fontSize: 11,
            fontFamily: "Atkinson Hyperlegible, sans-serif",
            letterSpacing: "normal",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          Growth marketing — owned media
        </div>
      </div>
    </div>
  );
};

export default Logo;
